import Quest from "./Quest";

export default class QuestDummy extends Quest {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);
    }
}